import { createApi } from '../client'

const api = createApi('/roles')

export default api
